import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  hasDataChanges(): boolean;
  showDiscardChangesModal(): Promise<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard
  implements CanDeactivate<CanComponentDeactivate>
{
  canDeactivate(
    component: CanComponentDeactivate
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Check if component has unsaved changes
    if (component.hasDataChanges()) {
      // Show modal and return the promise from the modal
      return component.showDiscardChangesModal();
    }

    // No changes, allow navigation
    return true;
  }
}
